import { render } from "./SideChatNavigation.vue?vue&type=template&id=8b9e0808"
import script from "./SideChatNavigation.vue?vue&type=script&lang=js"
export * from "./SideChatNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script